<template>
  <div>
    <status-list />

    <div>
      <button class="btn btn-primary" @click="previousStep">
        Wstecz
      </button>

      <button class="btn btn-primary float-right" @click="finish">
        Zakończ
      </button>
    </div>
  </div>
</template>

<script>
import { wizardStepMixin } from '@/mixins/wizardStep';
import StatusList from '@/views/mainRoute/status/List.vue';

// @vuese
// Statusy wzoru
// @group template
export default {
  components: { StatusList },
  mixins: [wizardStepMixin('template')],
  schema: {}, // wymagane przez mixin
  methods: {
    // @vuese
    // Przenosi do listy wzorów
    finish() {
      this.$router.push({ name: 'templateList' });
    }
  }
};
</script>
